export enum ApiActionEnum {
  INDEX = 'index',
  PROFILE_USER = 'profile',
  LOGIN = 'login',
  TRACE = 'trace',
  FILTER = 'filter',
  RANGE = 'range',
}
